import { render, staticRenderFns } from "./my-coupon.vue?vue&type=template&id=2fb5d3d2&scoped=true"
import script from "./my-coupon.vue?vue&type=script&lang=js"
export * from "./my-coupon.vue?vue&type=script&lang=js"
import style0 from "./my-coupon.vue?vue&type=style&index=0&id=2fb5d3d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb5d3d2",
  null
  
)

export default component.exports